import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { QueovalItem, QueovalItemModel } from '../models';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast/toast.service';
import { b64UrlEncodeUnicode } from '../utilities';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-autosearch',
  templateUrl: './autosearch.component.html',
  styleUrls: ['./autosearch.component.css']
})

export class AutoSearchComponent implements OnInit {
  // Search mode : STAGE-RESERVATION  CLIENTETTOUS  CLIENT
  mode: string = '';
  // eventual placeholder for the input text element
  inputPlaceHolder: string = '';
  // eventual button to bind to the input text element
  inputWithButton: boolean = false;
  // button to delete the input text element
  inputWithDelete: boolean = true;
  // input text content for the search function
  inputContentText: string = '';
  // style class for the input text element
  inputStyleClass: string = 'searchEmpty';
  customInputClass: string = '';
  // style class for the list result element
  listStyleClass: string = '';
  // show-hide list result element
  showList: boolean = false;
  // list result content
  list: Array<QueovalItem> = [];
  listOrigine: Array<QueovalItem> = [];
  isFromList: boolean = false;
  isDisabled: boolean = false;
  idSelectedOption: number = 0;

  @ViewChild('Input') Input!: ElementRef;

  @Output() SetInput: EventEmitter<QueovalItem> = new EventEmitter<QueovalItem>();

  @Input('Mode')
  set Mode(value: string) {
    this.mode = value ? value : '';
  }
  @Input('InputWithDelete')
  set InputWithDelete(value: boolean) {
    this.inputWithDelete = value;
  }
  @Input('CustomClass')
  set CustomClass(value: string) {
    this.customInputClass = value ? value : '';
  }
  @Input('InputText')
  set InputText(value: string) {
    this.inputContentText = value ? value : '';
  }
  @Input('IsDisabled')
  set IsDisabled(value: boolean) {
    this.isDisabled = value;
  }
  @Input('List')
  set _list(value: Array<QueovalItem>) {
    this.isFromList = true;
    this.list = value;
    this.listOrigine = value;
  }

  constructor(
    private httpservice: HttpService,
    private indParam: CoreService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
  
    switch (this.mode) {
      case 'STAGE-RESERVATION':
        this.inputPlaceHolder = this.indParam.getTrad('AssociateInternShip');
        this.inputContentText = '';
        // you can create in the css file the class for your input element and associate it to the element here
        this.inputStyleClass = 'searchEmpty';
        // you can create in the css file the class for your list element and associate it to the element here
        this.listStyleClass = 'listStage';
        break;
      case 'CLIENTETTOUS':
      case 'CLIENT':
        this.inputPlaceHolder = this.indParam.getTrad('SelectACorporation');
        // you can create in the css file the class for your input element and associate it to the element here
        this.inputStyleClass = 'searchEmpty';
        // you can create in the css file the class for your list element and associate it to the element here
        this.listStyleClass = 'listClient';
        // this.search();
        break;
      default:
        this.inputPlaceHolder = this.mode
        break;
    }
  }

  /** @description input text keyup event: for returning search result
   * @return
   */
  public search(event: any): void {
    if (event.key == 'ArrowUp' || event.key == 'ArrowDown' || event.key == 'Enter') {

      return;
    }

    if (this.inputContentText == '') {
      // this.toast.showWarningToast('input a text to search');
      this.cleanInput();
      this.showList = false;
      return;
    }
    if (this.mode === '') {
      this.toast.showWarningToast(this.indParam.getTrad('ModeNotSpecified'));
      return;
    }

    function makeDelay(ms: number): any {
      let timer: any = 0;
      return (callback: any): any => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    }

    const delay: any = makeDelay(500);
    delay(() => {
      if (this.isFromList) {
        if (this.inputContentText.length > 0) {
          this.list = this.listOrigine.filter((search) => search.Text.toLocaleLowerCase().startsWith(this.inputContentText.toLocaleLowerCase()));
        } else {
          this.list = this.listOrigine;
        }
        this.showList = this.list.length > 0;
        this.inputStyleClass = 'searchEmpty';
      } else {
        this.inputStyleClass = 'searchAction';
        if (this.inputContentText && this.inputContentText !== '' && this.mode && this.mode !== '') {
          const sendData: string = b64UrlEncodeUnicode(`${this.inputContentText}|${this.mode}`);
          this.httpservice.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/SEARCH/${sendData}/`)
            .subscribe((result: QueovalItemModel) => {
              if (!result.HasError) {
                this.list = result.queovalItemList;
                this.showList = this.list.length > 0;
                this.inputStyleClass = 'searchEmpty';
              }
            });
        }
      }
    });
  }

  private ActionArrowUpDown(up: boolean) {
    let posSelect: number = 0;
    let listSuggest: any = $(`.list-unstyled li`);
    listSuggest.each((el: any) => {
      if (listSuggest[el].id) {
        if (up) {
          if (el === 0) {
            posSelect = +listSuggest.length - 1
          } else {
            posSelect = el - 1
          }
        } else {
          if (listSuggest.length == +el + 1) {
            posSelect = 0
          } else {
            posSelect = el + 1
          }
        }
      }
      listSuggest[el].id = "";
    });
    listSuggest[posSelect].id = 'selectedSuggest';
    this.idSelectedOption = posSelect;


    let listClientElement = $(`.listClient`);
    let selectedSuggestElement = $(`#selectedSuggest`);
    if (listClientElement.scrollTop()) {
      if (selectedSuggestElement.position().top < 0) {
        listClientElement.scrollTop(listClientElement.scrollTop()! + selectedSuggestElement.position().top);
      } else if (selectedSuggestElement.position().top > 240) {
        listClientElement.scrollTop(listClientElement.scrollTop()! + selectedSuggestElement.position().top - listClientElement.height()!);
      }
    }
  }

  public getArrowKeys(event: any) {
    if (this.list.length > 0) {

      if (event) {
        switch (event.code) {

          case 'ArrowUp':
            this.ActionArrowUpDown(true);
            break;

          case 'ArrowDown':
            this.ActionArrowUpDown(false);
            break;

          case 'Enter':
            this.selectItem(this.list[this.idSelectedOption]);
            break;
        }
      }

    }
  }

  // Vide l'input et envoie l'item au composant parent
  public cleanInput(): void {
    const emptyItem: QueovalItem = new QueovalItem();
    emptyItem.Value = 'DELETE';
    emptyItem.Text = '';
    this.selectItem(emptyItem);
  }

  /** @description list result click element event: sent to the output property SetInput containing the parent function for this event
   * @param selectedType the selected list element
   * @return
   */
  public selectItem(item: QueovalItem): void {
    this.inputContentText = item.Text;
    this.SetInput.emit(item);
    this.showList = false;
  }
}





